import analyticsEvent from './analyticsEvent';

// const enquire = require('enquire.js');
// const paths = require('./paths');
// const howler = require('howler');



const audioElements = [...document.querySelectorAll('[data-audio-button]')];

if (audioElements.length) {
    const audio = document.getElementById('audio');
    let active = true;

    const initDesktop = () => {
        if (audio && typeof audio.play === 'function') {
            const promise = audio.play();

            if (typeof promise !== 'undefined') {
                promise.then(() => {
                    setAudioButtons();
                }).catch(() => {
                    active = false;
                    setIconsDisable();
                    setAudioButtons();
                });
            }
        }
    };

    const setAudioButtons = () => {
        audioElements.forEach(audioElement => {
            audioElement.addEventListener('click', clickHandler);
        });
    };

    const setIconsEnable = () => {
        audioElements.forEach(audioElement => {
            audioElement.classList.add('b-sound-enabled');
        });
    }

    const setIconsDisable = () => {
        audioElements.forEach(audioElement => {
            audioElement.classList.remove('b-sound-enabled');
        });
    }
   
    const clickHandler = () => {
        active = !active;

        if (active) {
            audio.play();
            analyticsEvent('Audio', 'click', 'Включить звук');
            setIconsEnable();
        } else {
            audio.pause();
            analyticsEvent('Audio', 'click', 'Выключить звук');
            setIconsDisable();
        }

    };

    initDesktop();
}



// WEBPACK FOOTER //
// ./js/audio.js